<template>
  <!-- <div class="menu" :style="styleList"> -->
  <div class="menu">
    <div class="muck-up">
      <div class="overlay">
        <!-- <img src="../img/louisa.png" > -->
      </div>
      <div class="top">
        <div class="nav">
          <span class="ion-android-menu"></span>
          <p>-</p>
          <!-- <cube-button style="margin-left: 200px ;width: 40%; background-color: transparent;" @click="Dedia">取消黑卡會員</cube-button> -->
        </div>
        <div class="user-profile">
          <!-- <img :src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'" class="card-item__bg"> -->
          <img v-if="!profileImg" src="../img/default.jpg" class="card-item__bg">
          <img v-else :src="profileImg" class="card-item__bg" border="0">
          <div class="user-details">
            <h4 style="padding: 5px;">{{ user }}</h4>
            <p>{{ info.brand }} 數位會員卡</p>
          </div>
        </div>
      </div>
      <cube-loading :size="25" class="loadingIcon" v-if="loading"></cube-loading>
      <div id="layer" v-if="loading"/>
      <!-- <div class="clearfix"></div> -->
      <!-- <div class="filter-btn">
        <a id="one" href="#"><i class="ion-ios-checkmark-outline"></i></a>
        <a id="two" href="#"><i class="ion-ios-alarm-outline"></i></a>
        <a id="three" href="#"><i class="ion-ios-heart-outline"></i></a>
        <a id="all" href="#"><i class="ion-ios-star-outline"></i></a>
        <span class="toggle-btn ion-android-funnel"></span>
      </div> -->
      <div class="clearfix"></div>
      <div class="bottom">
        <div class="title">
          <!-- <h3>profile</h3>
          <small>February 8,2015</small> -->
        </div>
        <ul class="tasks">
          <li class="two green">
            <span class="task-cat">姓名</span>
            <span class="task-title">{{user}}</span>
            <!-- <span class="task-time">2pm</span> -->
          </li>
          <li class="one red">
            <span class="task-cat">生日</span>
            <span class="task-title">{{ruentexProfile.birth}}</span>
            <!-- <span class="task-time">5pm</span> -->
          </li>

          <li class="one red">
            <span class="task-cat">住家地址</span>
            <span class="task-title">{{Address}}</span>
            <!-- <span class="task-time">3pm</span> -->
          </li>

          <li class="two green">
            <span class="task-cat">個人電話</span>
            <span class="task-title" style="margin-left: 20px;">{{phone}}</span>
            <span class="task-time" @click="Dedia"><i class="cubeic-edit"></i></span>
          </li>

          <li class="two green">
            <span class="task-cat">發卡日期</span>
            <span class="task-title">{{ ruentexProfile.cardIssueDate }}</span>
            <!-- <span class="task-time">2pm</span> -->
          </li>

          <li class="two green">
            <span class="task-cat">電子信箱</span>
            <span class="task-title">{{ email }}</span>
            <!-- <span class="task-time">2pm</span> -->
          </li>

          <li class="two green" v-if="exchangeRecord.length !== 0">
            <span class="task-cat" @click="showHistory = true" >兌換記錄</span>
            <span class="task-title" ></span>
            <!-- <span class="task-time">2pm</span> -->
          </li>

          <div class="history" v-if="showHistory === true">
            <div style=" background: white; z-index: 100000;box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2); hight: 60px; width: 100vw; top:0; position: fixed; display: flex; align-items: center; justify-content: space-between; align-content: space-between;">
              <div style="margin: 15px 0px;font-size: 19px;" @click="showHistory = false"><i class="cubeic-back"></i></div>
              <div style="margin: 0 0px 0px 130px; font-size: 17px; font-weight: 500;">兌換記錄</div>
              <cube-select style="margin: 5px 10px 5px 40px; border: none;"
                v-model="value"
                @change="change"
                :title="title"
                confirmTxt="確定"
                :auto-pop="autoPop"
                :placeholder="placeholder"
                :options="transFormRecord">
              </cube-select>
            </div>
            <!-- <div style="position: relative; margin: 200px auto;">
              <cube-button @click="showDateSegmentPicker">StartDate - EndDate</cube-button>
            </div> -->
            <div class="item-box" :style="{height: cal}">
            <!-- <div class="item-box" > -->
              <ul class="list">
                <div class="item" style="background: white;margin:15px; box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.1); border-radius: 5px;"  v-for="(record, index) in record"  :key="index">
                  <i class="cubeic-right" style="width: 10vw; font-size:38px; color: var(--main-color); margin-left: -10px;"/>
                  <div class="left" style="width: 20vw;">
                    <li class="title">兌換日期</li>
                    <li class="entitle">{{ record.date }}</li>
                  </div>
                    <!-- <li class="title">任務日期</li> -->
                  <div class="middle" style="width:20vw;">
                    <li class="title">兌換序號</li>
                    <li class="entitle">{{ record.serialNo }}</li>
                  </div>
                  <div class="right" style="width:20vw;">
                    <li class="title">使用點數</li>
                    <li class="entitle">{{ record.point }}</li>
                  </div>
                </div>
              </ul>
            </div>
            <div class="loading">
              <div class="ball"></div>
              <div class="ball"></div>
              <div class="ball"></div>
            </div>
          </div>
          <!-- <li class="two green">
            <span class="task-title"><button style="border: none; background-color: transparent;" @click="Dedia">取消黑卡</button></span>
            <span class="task-time">2pm</span>
            <span class="task-cat">刪除會員</span>
          </li> -->
          <!-- <li class="tow green hang">
            <span class="task-title">Team Meeting</span>
            <span class="task-time">2pm</span>
            <span class="task-cat">Hangouts</span>
            <img src="https://raw.githubusercontent.com/arjunamgain/FilterMenu/master/images/2.jpg">
            <img src="https://raw.githubusercontent.com/arjunamgain/FilterMenu/master/images/3.jpg">
            <img src="https://raw.githubusercontent.com/arjunamgain/FilterMenu/master/images/profile.jpg">
          </li> -->

        </ul>
      </div>
      <div style="height: 200px;"></div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue';
const testR = ['20210925','20210825','20210725','20210425','20210125','20201125']
export default {
  data () {
    return {
      cal: '',
      record: [],
      title: '兌換日期',
      placeholder: '選擇日期',
      autoPop: true,
      value: '',
      options: [],
      dateSegmentData: [
        {
          is: 'cube-date-picker',
          title: '選擇起始日期',
          min: '',
          max: new Date(2030, 11, 31)
        },
        {
          is: 'cube-date-picker',
          title: '選擇結束日期',
          min: new Date(2000, 0, 1),
          max: new Date(2030, 11, 31)
        }
      ],
      showHistory: false,
      newPhone: '',
      tempCode: '',
      loading:false,
      number: 0,
      // brand: localStorage.getItem('brand'),
      styleList: {
        height: '600px',
        overflow: 'auto',
        margin: '',
      },
      currentCardBackground: Math.floor(Math.random()* 25 + 1),
      invoice: [],
      codeTest: false,
      orderNumb: '',
      orderCode: '',
      codetype: 'qr',
      deadLine: '',
      rigisterTime: '',
      pickTime: '',
      dialogQrcode: false,
      unveil:false,
      visible: false,
      remessage: false,
      alert: false,
      alertmessage: '',
      qrCode: '',
      barCode: '',
      list: {},
      status: '',
      cup: '',
      eilisID: '',
      userPhone: '',
      userName: '',
      userAddress: '',
      registerShop: '',
      transFormRecord: [],
      platform: 'mobile',
      channelData: {
        qrcode: this.$route.query.qrcode,
        trigger: this.$route.query.trigger,
        PageID: this.$route.query.Page
      },
    }
  },
  props: ['points', 'user', 'Birth', 'Address', 'phone', 'gender', 'saleroom','email', 'eid', 'profileImg', 'exchangeRecord'],
  mounted() {
    // console.log(this.exchangeRecord);
    if (this.exchangeRecord) {
      const Year = new Date().getFullYear().toString();
      // console.log(Year);
      // const Month = (new Date().getMonth()+1).toString() < 10 ? `${(new Date().getMonth()+1).toString()}` : (new Date().getMonth()+1).toString();
      let a = []
      for (let i = 0; i < this.exchangeRecord.length; i ++) {
        if (this.exchangeRecord[i].substr(0,4) === Year) {
          a.push(this.exchangeRecord[i].substr(0,6))
        }
      }
      a = a.filter((item, index) => a.indexOf(item) === index); // 過濾陣列相同值
      this.transFormRecord = a.sort((a, b) => b - a)
    }
    // console.log(parseInt(this.exchangeRecord[0].substr(0,4)));
    // console.log(parseInt(this.exchangeRecord[0].substr(4,2)));
    // console.log(parseInt(this.exchangeRecord[0].substr(6,2)));
    // console.log(this.dateSegmentData[0].min);
    // this.dateSegmentData[0].min = new Date(parseInt(this.exchangeRecord[0].substr(0,4)),parseInt(this.exchangeRecord[0].substr(4,2)) - 1 ,parseInt(this.exchangeRecord[0].substr(6,2)))
    // console.log(this.dateSegmentData[0].min);
    // this.dateSegmentPicker = this.$createSegmentPicker({
    //   data: this.dateSegmentData,
    //   onSelect: (selectedDates, selectedVals, selectedTexts) => {
    //     this.$createDialog({
    //       type: 'warn',
    //       content: `Selected Items: <br/> - 選擇起始日期: ${selectedTexts[0].join('')} <br/> - 選擇結束日期: ${selectedTexts[1].join('')}`,
    //       icon: 'cubeic-alert',
    //       text: '確定',
    //     }).show()
    //   },
    //   onNext: (i, selectedDate, selectedValue, selectedText) => {
    //     this.dateSegmentData[1].min = selectedDate
    //     if (i === 0) {
    //       this.dateSegmentPicker.$updateProps({
    //         data: this.dateSegmentData,
    //       })
    //     }
    //   }
    // })
    // this.styleList.height = `${window.screen.height * 0.7}px`;
  },
  computed: {
    ...mapGetters({
      info: 'info',
      brandCode: 'brandCode',
      ruentexProfile: 'ruentexProfile'
    }),
  },
  methods: {
  ...mapActions({
      deleteUser: 'deleteUser',
      ChTextMsg: 'ChTextMsg',
      updateMember: 'updateMember',
      updatePhoneNumber: 'updatePhoneNumber',
      checkPhoneNumbers: 'checkPhoneNumbers',
      getCouponHistory: 'getCouponHistory'
    }),
    change(value, index, text) {
      // console.log(value, index, text)
      const year = value.substr(0,4);
      const month = value.substr(4,6);
      var firstDay = `${value}01`
      var lastDay = new Date(year,month,0).toLocaleDateString().replace('/','').replace('/','')
      // console.log(firstDay);
      // console.log(lastDay);
      var fDay = lastDay.length === 8 ? lastDay.substr(6,8)  : lastDay.substr(5,7)
      // console.log(fDay);
      const finalDay = `${value}${fDay}`
      // console.log(finalDay);
      const loading = document.querySelector('.loading');
      loading.classList.add('show');
      this.getCouponHistory({ clientId: this.info.clientId, begin: firstDay, end: finalDay, storeId: this.saleroom, phone: this.phone,})
      .then((res) => {
        // console.log(res);
        this.record = res.data.result.filter(el => el.date.substr(0,4) === year)
        this.cal = (110 * res.data.result.length.toString()) + 'px'
        loading.classList.remove('show');
        // console.log(res);
        // console.log(this.cal);
      })
    },
    showDateSegmentPicker() {
      this.dateSegmentPicker.show()
    },
    Dedia() {
      // localStorage.removeItem('Member');
      // localStorage.removeItem('AuthToken');
      // localStorage.removeItem('Service');
      this.$createDialog({
        type: 'confirm',
        title: '系統通知',
        content: '要修改您的電話嗎？',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          this.dialog = this.$createDialog({
            type: 'prompt',
            title: '請輸入電話',
            prompt: {
              value: this.memberAccount,
              placeholder: ''
            },
            confirmBtn: {
              text: '確定',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            cancelBtn: {
              text: '上一頁',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            onCancel: () => {
              this.Dedia()
            },
            onConfirm: (e, promptValue) => {
              this.loading = true;
              // promptValue = null;
              // setTimeout(() => {
              //   this.addCode();
              this.checkPhoneNumbers({ phone: promptValue, clientId: this.info.clientId,})
              .then((res) => {
                // console.log(res);
                if (res.data.result.phone) {
                  const contents = '更改電話已存在!'
                  this.showAlert1(contents)
                  this.loading = false;
                  return;
                } else if (this.phone === promptValue) {
                  const contents = '更改電話與當前電話相同!'
                  this.loading = false;
                  return this.showAlert1(contents)
                // return alert('更改電話與當前電話相同。')
                } else if (promptValue === ''){
                  const contents = '請輸入修改電話'
                  this.loading = false;
                  return this.showAlert1(contents)
                }
              // if (this.phone === promptValue) {
              //   const contents = '更改電話與當前電話相同!'
              //   return this.showAlert1(contents)
              //   // return alert('更改電話與當前電話相同。')
              // } else if (promptValue === ''){
              //   const contents = '請輸入修改電話'
              //   return this.showAlert1(contents)
              // }
              this.newPhone = promptValue;
              const re = /^[0-9]+$/;
              if (!re.test(promptValue)) {
                const contents = '請輸入正確格式'
                this.showAlert1(contents)
                this.Dedia()
              } else if (promptValue.length > 10) {
                const contents = '請輸入正確數字'
                this.showAlert1(contents)
                this.Dedia()
              } else {
                this.loading = true;
                //
                const sixcodes = `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}`;
                this.tempCode = sixcodes;
                // service:FB OR LINE ,gate: channel ID or FB ID
                const words = `您好，感謝您修改${this.info.brand} Taiwan會員資料，您的驗證碼為:`;
                const wordsSecond = `記得完成驗證步驟，繼續與我們一同品嘗好茶喔`
                // promptValue = '';
                // this.addCode();
                // return;
                //
                this.ChTextMsg({ phone: promptValue, msg: words + sixcodes + '' + wordsSecond, brand: this.brandCode,})
                .then((res)=> {
                  // console.log(res);
                  const empty = '';
                  promptValue = empty
                  if (res.data.text !== 'mobile tag error') {
                    this.b();
                    const toast = this.$createToast({
                      time: 1500,
                      txt: '驗證碼已送出'
                    })
                    toast.show()
                    this.loading = false;
                    // promptValue = empty
                    setTimeout(() => {
                      this.addCode();
                    },1500)
                  } else {
                    this.showAlert(res.data.text);
                    this.loading = false;
                  }
                });
                //
              }
              });
            },
          }).show()
        },
      }).show()
    },
    showAlert1(contents) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: contents,
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    showAlert(val) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: val,
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // icon: 'cubeic-alert'
      }).show()
    },

    addCode() {
      this.dialog = this.$createDialog({
        type: 'prompt',
        title: '請輸入驗證碼',
        prompt: {
          value: '',
          placeholder: '請輸入'
        },
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: (e, promptValue) => {
          this.loading = true;
          // console.log(promptValue);
          // console.log(this.info.clientId);
          // console.log(this.newPhone);
          if (promptValue.length > 6) {
            promptValue = promptValue.slice(0, 6)
            if (this.tempCode === promptValue) {
              this.updatePhoneNumber({clientId: this.info.clientId, oldPhone: this.phone, newPhone: this.newPhone,})
              .then(() => {
                this.loading = false;
                const toast = this.$createToast({
                  txt: `電話更新成功`,
                  type: 'correct'
                })
                toast.show()
                window.location.reload();
              })
            } else {
              this.loading = false;
              const toast = this.$createToast({
                txt: `驗證碼錯誤`,
                type: 'correct'
              })
              toast.show()
              setTimeout(()=>{
                toast.hide()
              },700)
              this.addCode()
              // window.location.reload();
            }
          } else if (this.tempCode === promptValue) {
            // console.log(this.tempCode);
            this.updatePhoneNumber({clientId: this.info.clientId, oldPhone: this.phone, newPhone: this.newPhone,})
            .then((res) => {
              // console.log(res);
              this.loading = false;
              const toast = this.$createToast({
                txt: `電話更新成功`,
                type: 'correct'
              })
              toast.show()
              window.location.reload();
            })
          } else {
            this.loading = false;
            const toast = this.$createToast({
              txt: `驗證碼錯誤`,
              type: 'correct'
            })
            toast.show()
            setTimeout(()=>{
              toast.hide()
            },700)
            this.addCode()
          }
        },
      }).show()
    },
    a() {
      this.number -= 1;
    },
    b() {
      this.number = 300;
      var si = setInterval(this.a, 1000);
      setTimeout(() => {
        this.number = '';
        // this.phoneVerify = true;
        clearInterval(si);
      }, 300000);
    },
  }
}
</script>

<style lang="scss" scoped>
  body {
  font: 300 14px/18px Roboto
}

*,
:after,
:before {
  box-sizing: border-box
}

.clearfix:after,
.clearfix:before {
  content: '';
  display: table
}

.clearfix:after {
  clear: both;
  display: block
}

.loadingIcon {
    z-index: 100000;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    // margin-top: -270px;
    width: 55px;
    height: 55px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #717171;
    -webkit-text-fill-color: transparent;
  }
  .item-box {
    padding-left: 0!important;
    padding-right: 0!important;
    // height: calc(100vh + 50px);
    // height: 5000px;
    margin-top: 12%;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    // overflow: auto;
    // -webkit-overflow-scrolling: touch;
  }
  .item-box .list{
    padding-left: 0!important;
    padding-right: 0!important;
    text-align: left;
    height: 100px;
    width: 100%;
    max-width: 400px;
    margin: 0px;
    padding: 0px;
    // overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
    // padding-bottom: 70px;
  }
  .item-box .list .item {
    // margin-top: 7px;
    display: flex;
    //overflow-y: auto;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    // border-bottom: 1px solid rgba(210, 210, 210, 0.815);
    height: 85px;
    padding: 25px;
  }
  .item-box .list .item .left .entitle{
    margin-left: 0px;
    // margin-top: 2px;
    // color: rgba(67, 67, 67, 0.851);
    font-size: 14px;
    // font-weight: 400;
    letter-spacing: 1px;
  }
  .item-box .list .item .middle .title {
    margin-top: 0px;
    color: rgba(0, 0, 0, 0.851);
    font-size: 14px;
    // font-weight: 500;
    display: flex;
    letter-spacing: 1px;
    justify-content: space-between;
  }
  .item-box .list .item .middle .entitle {
    // margin-top: 2px;
    margin-left: 0px;
    color: rgba(67, 67, 67, 0.851);
    font-size: 14px;
    // font-weight: 400;
    letter-spacing: 1px;
  }
  .item-box .list .item .right {
    margin-right: -10px;
    // margin-top: 2px;
    // color: rgba(67, 67, 67, 0.851);
    font-size: 14px;
    // font-weight: 400;
    letter-spacing: 1px;
  }
  .item-box .list .item .right .title {
    // margin-top: 2px;
    margin-left: 10px;
    // color: rgba(67, 67, 67, 0.851);
    font-size: 14px;
    // font-weight: 400;
    letter-spacing: 1px;
  }
  .item-box .list .item .right .entitle {
    // margin-top: 2px;
    margin-left: 25px;
    color: rgba(67, 67, 67, 0.851);
    font-size: 14px;
    // font-weight: 400;
    letter-spacing: 1px;
  }
  #layer{
    z-index: 100000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(159, 159, 159, 0.527);
  }
  .menu {
    // padding-bottom: 10px;
    // overflow: scroll;
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    // overflow: hidden;
    width: 100%;
    max-width: 540px;
    height: 612px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .history {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // overflow: scroll;
    // height: calc(100vh);
    z-index: 100000000000;
    padding-left: 0!important;
    padding-right: 0!important;
    width: 100%;
    max-width: 500px;
    background-color: #ffffff;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .muck-up {
    z-index: 1;
    min-width: 310px;
    padding-bottom: 80px;
    // height: calc(100vh + 100px);
    margin: 0em auto;
    position: relative;
    overflow: hidden;
  }

.overlay {
  // background-color: var(--main-color);
  // background: url(https://raw.githubusercontent.com/arjunamgain/FilterMenu/master/images/header.jpg) no-repeat top /contain;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.overlay:after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  // background: rgba(71, 32, 84, 0.5);
}

.top {
  // z-index: 100000;
  position: relative;
  min-height: 230px;
  padding: 20px;
  color: rgb(159, 159, 159);
}
// .muck-up > .top {
//   // z-index: 100000;
//   // position: relative;
//   min-height: 250px;
//   padding: 25px;
//   color: #fff;
// }

.top .nav span {
  float: left;
  display: block;
}

.nav p {
  margin-top: 2px;
  display: inline-block;
  // float: left;
  vertical-align: bottom;
}

.ion-android-menu {
  font-size: 24px;
  margin-right: 17px;
}

.nav .ion-ios-more-outline {
  font-size: 38px;
  float: right !important;
}

.user-profile {
  margin-top: 70px;
  // z-index: 10000000;
}

.user-profile img {
  height: 75px;
  width: 75px;
  border-radius: 50%;
  float: left;
  margin-right: 24px;
}

.user-details p {
  font-size: 11px;
}

.user-details {
  float: left;
  margin-top: 23px;
  vertical-align: bottom;
}

.user-details h4 {
  font-size: 25px;
}

.filter-btn {
  position: absolute;
  z-index: 2;
  right: 0;
  width: 40px;
  height: 40px;
  transition: all 0.4s ease-in-out 0s;
}

.filter-btn span {
  width: 40px;
  height: 40px;
  background: #FA396B;
  display: block;
  position: absolute;
  right: 25px;
  top: -46px;
  text-align: center;
  color: #fff;
  line-height: 40px;
  border-radius: 50%;
  font-size: 22px;
  z-index: 999;
}
span.toggle-btn.ion-android-funnel:hover{
      cursor: pointer;
}
.filter-btn a {
  position: absolute;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  right: 25px;
  display: block;
  top: -46px;
  color: #fff;
  z-index: 99;
  font-size: 22px;
  transition: all .4s cubic-bezier(.68, 1, .265, 1)
}

.filter-btn:after {
  height: 170px;
  width: 170px;
  content: '"\f38b"';
  background-color: #FA396B;
  position: absolute;
  top: -110px;
  right: -40px;
  border-radius: 50%;
  transform: scale(0);
  transition: all 0.3s ease-in-out 0s;
}

.filter-btn.open span.toggle-btn.ion-android-funnel {
  background-color: #DE3963;
}

.filter-btn.open .ion-android-funnel:before {
  content: "\f2d7";
}

.open:after {
  transform: scale(1);
}

.filter-btn.open a:nth-child(1) {
  transform: translate(9px, -62px);
}

.filter-btn.open a:nth-child(2) {
  transform: translate(-50px, -34px);
}

.filter-btn.open a:nth-child(3) {
  transform: translate(-56px, 25px);
}

.filter-btn.open a:nth-child(4) {
  transform: translate(5px, 61px);
}

.muck-up .bottom {
  // top: 10px;
  background-color: #fff;
  min-height: 350px;
  z-index: 1;
  padding: 35px;
  position: relative;
  color: #222;
  padding-top: 0px;
}

.bottom:after {
  content: '';
  position: absolute;
  top: -40px;
  background: #fff;
  left: -22px;
  right: 0;
  height: 100px;
  transform: rotate(10deg);
  min-width: 400px;
  z-index: -1;
}

.bottom .title {
  margin-bottom: 20px;
}

.bottom .title h3 {
  font-size: 22px;
  margin-bottom: 5px;
}

ul.tasks {
  height: 500px;
}

.title small {
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
}

ul.tasks .task-title {
  font-size: 15px;
  display: inline-block;
}

ul.tasks .task-time {
  float: right;
  font-size: 10px;
  color: #888;
}

ul.tasks .task-cat {
  margin: 8px;
  font-size: 17px;
  display: block;
  color: #888;
}

ul.tasks li {
  margin-bottom: 5px;
  position: relative;
  z-index: 8;
}

ul.tasks li:after {
  content: '';
  position: absolute;
  left: -18px;
  top: 8px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
}

ul.tasks li.red:after {
  background: #FF3163;
}

ul.tasks li.green:after {
  background: #54D6C7;
}

ul.tasks li.yellow:after {
  background: #EAB429;
}

ul.tasks::after {
  content: '';
  position: absolute;
  height: 400px;
  width: 1px;
  background: #eee;
  left: 20px;
  top: -68px;
}

ul li.hang {
  margin-bottom: 48px;
}

ul li.hang img {
  float: left;
  height: 20ox;
  width: 20px;
  border-radius: 50%;
  margin-right: 8px;
}
.loading.show {
    opacity: 1;
  }

  .ball {
    background-color: #777;
    border-radius: 50%;
    margin: 5px;
    height: 10px;
    width: 10px;
    animation: jump .5s ease-in infinite;
  }

  .ball:nth-of-type(2) {
    animation-delay: 0.1s;
  }

  .ball:nth-of-type(3) {
    animation-delay: 0.2s;
  }
  @keyframes myframes1 {
    0% {
      -webkit-transform: scale(0) translateY(200px) rotate(0deg);
            transform: scale(0) translateY(200px) rotate(0deg);
    }
    50% {
      -webkit-transform: scale(0.5) rotate(0deg);
              transform: scale(0.5) rotate(0deg);
    }
    80% {
      -webkit-transform: scale(0.8) rotate(0deg);
              transform: scale(0.8) rotate(0deg);
    }
    100% {
    -webkit-transform: scale(1) translateY(0px) rotate(0deg);
      transform: scale(1) translateY(0px) rotate(0deg);
    }
  }
  @keyframes jump {
    0%, 100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-10px);
    }
  }
</style>
